import { ComposedElement } from "../ComposedElement.mjs";
export var HeadingNode;

(function (HeadingNode) {
  var Type;

  (function (Type) {
    Type["HEADING_ONE"] = "heading-one";
    Type["HEADING_TWO"] = "heading-two";
  })(Type = HeadingNode.Type || (HeadingNode.Type = {}));

  var Role;

  (function (Role) {
    Role["TITLE"] = "title";
    Role["SUBTITLE"] = "subtitle";
  })(Role = HeadingNode.Role || (HeadingNode.Role = {}));

  function isHeadingNode(value, type) {
    if (type === undefined) {
      return ComposedElement.isComposedElement(value) && (value.type === Type.HEADING_ONE || value.type === Type.HEADING_TWO);
    }

    return ComposedElement.isComposedElement(value, type);
  }

  HeadingNode.isHeadingNode = isHeadingNode;

  function isTitleHeadingNode(value) {
    return isHeadingNode(value) && value.role === HeadingNode.Role.TITLE;
  }

  HeadingNode.isTitleHeadingNode = isTitleHeadingNode;

  function isSubtitleHeadingNode(value) {
    return isHeadingNode(value) && value.role === HeadingNode.Role.SUBTITLE;
  }

  HeadingNode.isSubtitleHeadingNode = isSubtitleHeadingNode;

  function validateHeadingNode(value) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    if (params.length === 2) {
      var [type, _validateChildNode] = params;

      var _isValid = ComposedElement.validateComposedElement(value, type, _validateChildNode);

      return _isValid ? value : null;
    }

    var [validateChildNode] = params;
    var isValid = isHeadingNode(value) && ComposedElement.validateComposedElement(value, value.type, validateChildNode);
    return isValid ? value : null;
  }

  HeadingNode.validateHeadingNode = validateHeadingNode;
})(HeadingNode || (HeadingNode = {}));